import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import './index.css';

const contenedor = document.getElementById('root');
if (contenedor === null) {
  throw new Error('No se encontro el elemento raiz de la aplicacion.');
}

createRoot(contenedor).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
